"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var BotInfo_1 = __importDefault(require("./common/BotInfo"));
var Composer_1 = __importDefault(require("./Composer"));
var ConversationList_1 = __importDefault(require("./ConversationList"));
var Footer_1 = __importDefault(require("./Footer"));
var Header_1 = __importDefault(require("./Header"));
var Keyboard = __importStar(require("./Keyboard"));
var MessageList_1 = __importDefault(require("./messages/MessageList"));
var OverridableComponent_1 = __importDefault(require("./OverridableComponent"));
var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Container.prototype.renderBody = function () {
        if (!this.props.isInitialized) {
            return (react_1.default.createElement("div", { className: "bpw-msg-list-container bpw-msg-list-container-loading" },
                react_1.default.createElement("div", { className: "bpw-msg-list-loading" })));
        }
        if (this.props.isConversationsDisplayed) {
            return react_1.default.createElement(ConversationList_1.default, null);
        }
        else if (this.props.isBotInfoDisplayed) {
            return react_1.default.createElement(BotInfo_1.default, null);
        }
        else {
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)('bpw-msg-list-container', {
                    'bpw-emulator': this.props.isEmulator,
                    'bpw-rtl': this.props.rtl
                }) },
                react_1.default.createElement(MessageList_1.default, null),
                react_1.default.createElement(Keyboard.Default, null,
                    react_1.default.createElement(OverridableComponent_1.default, { name: 'composer', original: Composer_1.default }))));
        }
    };
    Container.prototype.render = function () {
        var _a;
        var classNames = (0, classnames_1.default)('bpw-layout', 'bpw-chat-container', (_a = {
                'bpw-layout-fullscreen': this.props.isFullscreen && 'fullscreen'
            },
            _a["bpw-anim-".concat(this.props.sideTransition)] = true,
            _a));
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(OverridableComponent_1.default, { name: 'before_container', original: null }),
            react_1.default.createElement("div", { className: classNames, style: { width: this.props.dimensions.layout } },
                react_1.default.createElement(Header_1.default, null),
                this.renderBody(),
                react_1.default.createElement(OverridableComponent_1.default, { name: 'below_conversation', original: null }),
                this.props.isPoweredByDisplayed && react_1.default.createElement(Footer_1.default, null))));
    };
    return Container;
}(react_1.default.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        store: store,
        isConversationsDisplayed: store.view.isConversationsDisplayed,
        isBotInfoDisplayed: store.view.isBotInfoDisplayed,
        isFullscreen: store.view.isFullscreen,
        sideTransition: store.view.sideTransition,
        dimensions: store.view.dimensions,
        isEmulator: store.isEmulator,
        isInitialized: store.isInitialized,
        isPoweredByDisplayed: store.view.isPoweredByDisplayed,
        config: store.config,
        botName: store.botName,
        rtl: store.rtl
    });
})((0, react_intl_1.injectIntl)((0, mobx_react_1.observer)(Container)));
